var exports = {
  "Nr": "card__YP6j-k",
  "ir": "reference__m9089L",
  "n5": "referenceText__fHrVqn",
  "z$": "referenceName__Rss0Vq",
  "$D": "titleHeading__GLZH1i",
  "DD": "title__Ro3HnD",
  "OA": "fields__G8Ijj4",
  "aB": "fieldTooltip__7B2U0A",
  "dC": "fieldValueToken__atfcFc",
  "CB": "subIssuesProgressCircle__4vNrFN",
  "VK": "parentIssueToken__IhCmqq",
  "J_": "parentIssueState__xZXoc1",
  "kJ": "tooltipHidden__jIuCtR",
  "UK": "assigneeButton__1JVlWS",
  "Jf": "labelOverflowButton__eqYo01",
  "bi": "labelOverflowList__uvtPCs",
  "Hy": "assignees__iBVU9v",
  "vL": "assigneeItem__Smxt-P",
};

module.exports = exports;
